import adminAPI from "../../api/apiAdmin";

class AdminInvoiceService {

    static async list(params = {}) {
        const response = await adminAPI.get("/admin/invoices", { params });
        return response.data;
    }

    static async create(data) {
        return adminAPI.post("/admin/invoices", data);
    }

    static async getSettings() {
        const response = await adminAPI.get("/admin/invoices/settings");
        return response.data;
    }

    static async updateSettings(data) {
        return adminAPI.patch("/admin/invoices/settings", data);
    }

    static async getDetail(id) {
        const response = await adminAPI.get(`/admin/invoices/${id}`);
        return response.data;
    }

    static async updateEmail(id, email) {
        const response = await adminAPI.patch(`/admin/invoices/${id}/email`, { email });
        return response.data;
    }

    static async download(id) {
        return adminAPI.get(`/admin/invoices/${id}/download`, {
            responseType: 'blob'
        });
    }

    static async updateStatus(id, status) {
        const response = await adminAPI.patch(`/admin/invoices/${id}/status`, { status });
        return response.data;
    }

    static async share(id) {
        const response = await adminAPI.post(`/admin/invoices/${id}/share`);
        return response.data;
    }

}

export default AdminInvoiceService;
